import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createApplicationContext } from '../applicationContext';

export function runApp() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  renderApplication({ store, context });
}
